import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BoatyardComponent } from './boatyard.component';
import { BoatyardResolve } from './boatyard.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/boatyard',
        component: BoatyardComponent,
        resolve: {
          portal: BoatyardResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class BoatyardRoutingModule {}
